import * as classnames from 'classnames'
import * as React from 'react'

import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import SafeInnerHtml from '../../../components/safeInnerHtml'
import ImagePlaceholder from '../../../v0/components/imagePlaceholder'

import * as styles from './tutorialPost.module.css'

interface IProps {
  imgSrc: string
  title: string
  link: string
  description: string
  hideOnMobile?: boolean
}

const TutorialPost = ({
  imgSrc,
  title,
  link,
  description,
  hideOnMobile
}: IProps) => {
  const rootClassNames = classnames(styles.root, {
    [styles.hideOnMobile]: hideOnMobile
  })
  return (
    <article className={rootClassNames}>
      <header>
        <a href={link} aria-label={title}>
          <ImagePlaceholder className={styles.placeholder}>
            <EnhancedLazyLoad>
              <img alt={title} src={imgSrc} className={styles.img} />
            </EnhancedLazyLoad>
          </ImagePlaceholder>
        </a>
        <a href={link} className={styles.title}>
          {title}
        </a>
      </header>
      <section className={styles.description}>
        <SafeInnerHtml html={description} />
      </section>
    </article>
  )
}

export default TutorialPost
